import { Component, Input } from '@angular/core';
import { NotificationType } from '@shared/models';
import { ComponentContext, NotificationInfo } from '../modal.model';

@Component({
  selector: 'gcc-notification-details',
  templateUrl: './notification-details.component.html',
  styleUrls: ['./notification-details.component.scss'],
  standalone: false
})
export class NotificationDetailsComponent implements ComponentContext<NotificationInfo> {
  @Input() public title: string;
  @Input() public description: string;
  @Input() public type: NotificationType;

  @Input() public onAction: () => void;
  @Input() public onClose: () => void;

  public notificationType = NotificationType;
}
